import { render } from "./FlashMessage.vue?vue&type=template&id=fe590d72&scoped=true"
import script from "./FlashMessage.vue?vue&type=script&lang=js"
export * from "./FlashMessage.vue?vue&type=script&lang=js"

import "./FlashMessage.vue?vue&type=style&index=0&id=fe590d72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fe590d72"

export default script